<div
  class="int-select"
  #rootElement
  *ngIf="{
  isFocus: (isFocus$ | async),
  currentValue: (value$ | async),
  list: (list$ | async),
  animaite: (animation$ | async )
  } as streams$"
>
 <int-input
   #intInput
  [readonly]="readonly"
  [defaultHeightPriority]="defaultHeightPriority"
  [placeholder]="placeholder"
  [label]="label"
  [defaultHeight]="defaultHeight"
  [showLabelTip]="showLabelTip"
  (onFocusEvent)="focusHandler($event)"
  [value]="value"
 >
   <ng-container ngProjectAs="right-position">
     <int-dropdown-chevron (onClick)="toggleField()" [isActive]="streams$.isFocus"></int-dropdown-chevron>
   </ng-container>
 </int-input>
  <ng-template #droptest let-payload="payload">
    <div class="dropdown"
         [@dropdown]="(streams$.animaite) ? 'open' : 'close'"
         [style]="{
           top: verticalAlign === 'top' ? payload.y + verticalOffset + 'px' : 'auto',
           bottom: verticalAlign === 'bottom' ? payload.y + verticalOffset + 'px' : 'auto',
           left: payload.x + 'px',
           width: payload.width + 'px'
         }"
    >
      <ul class="dropdown__list" [style]="{'maxHeight': dropdownHeight}" *ngIf="isOptionsExist; else empty">
        <li
          tabindex="-1"
          class="dropdown__item"
          *ngFor="let item of streams$.list"
          (mousedown)="handleChange(item)">
          <span
            class="dropdown__item-label"
            [class.dropdown__item-label--is-active]="item.value === payload.currentValue">
            {{ item.label }}
          </span>
        </li>
      </ul>
    </div>
  </ng-template>
</div>

<ng-template #empty>
  <div class="dropdown__list">
    <span class="empty-placeholder">{{ emptyListPlaceholder || 'Options not found' }}</span>
  </div>
</ng-template>


